export const useSetRefreshTokenExpiration = () => {
  const env = useRuntimeConfig();

  const refreshTokenExpiresAt = useCookie<number | null>("refresh_exp", {
    path: "/",
    maxAge: 60 * 60 * 24 * 30,
    domain: env.public.hurstDomain as string | undefined,
  });

  return (refreshTokenExpiresIn: number | null) => {
    if (!refreshTokenExpiresIn) {
      refreshTokenExpiresAt.value = null;

      return;
    }

    refreshTokenExpiresAt.value =
      new Date().getTime() + refreshTokenExpiresIn * 1000;

    refreshCookie("refresh_exp");
  };
};
